import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { getBaseValue, KpiReport } from "../processors";
import { FigureSolidDashKpiProvider } from "./categoryChartData.types";
import _ from "lodash";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { getFigureAndSolidDashGraph } from "../../Components/misc";

export const getOperatingSurplus = (kpis: string[][], yearBasedResults: KpiReport[]): KpiReport => {
    if (!kpis || kpis?.length === 0 || !yearBasedResults || yearBasedResults?.length === 0) return {} as KpiReport;
    const revenueKpi = kpis?.[0]?.[0];
    const costKpis = kpis.filter((__, index) => index > 0 && index < kpis?.length - 1).map(d => d?.[0]);

    const depreciationKpis = kpis.filter((__, index) => index === kpis?.length - 1).map(d => d?.[0]);

    if (!revenueKpi || !costKpis || !depreciationKpis) return {} as KpiReport;

    const costKpiMap = costKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const depreciationKpiMap = depreciationKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const revenueResult = yearBasedResults.find(d => d.kpiCode === revenueKpi);
    const costResults = yearBasedResults.filter(d => costKpiMap[d.kpiCode] === 1);
    const depreciationResults = yearBasedResults.filter(d => depreciationKpiMap[d.kpiCode] === 1);

    if (revenueResult?.value == null || !costResults?.length) return {} as KpiReport;

    if (revenueResult?.value === 0) {
        return {
            ...revenueResult,
            indicatorTitle: "",
            comment: null,
            kpiCode: null,
            value: 0,
            unit: "%"
        };
    }

    const totalCosts = _.sum(costResults.filter(d => d.value != null).map(d => getBaseValue(d.value, d.unit)?.value));
    const totalDepreciation = _.sum(
        depreciationResults.filter(d => d.value != null).map(d => getBaseValue(d.value, d.unit)?.value)
    );

    const ratio =
        ((getBaseValue(revenueResult?.value, revenueResult.unit)?.value - (totalCosts - totalDepreciation)) * 100) /
        getBaseValue(revenueResult?.value, revenueResult.unit)?.value;

    return {
        ...revenueResult,
        indicatorTitle: "",
        comment: null,
        kpiCode: null,
        value: ratio,
        unit: "%"
    };
};

// export const getFigureAndGraphForOperatingSurplusRatio = (
//     results: KpiReport[],
//     provider: WaterProvider,
//     kpis: string[][],
//     categoryChart: CategoryChart,
//     category: Category,
//     years?: number[]
// ): {
//     unit?: Unit;
//     year?: number;

//     figure: {
//         header?: LongText;
//         value: number | string;
//         decimals: number;
//         footer?: LongText;
//     };

//     graph?: {
//         header?: LongText;
//         years: number[];
//         largeProviderAverageData: number[];
//         largeProviderAverageSeriesName: string;
//         lineData: number[];
//         lineDataSeriesName: string;
//         footer?: LongText;
//     };
// } => {
//     const providerResults = results.filter(d => d?.provider?.tid === provider?.tid);
//     const yearToResults = _.groupBy(providerResults, d => d.year);
//     // const yearToAllResults = _.groupBy(results, d => d.year);
//     const yearProviderKeyFn = (year: number, tid: number) => `${year} %%% ${tid}`;

//     const yearProviderToAllResults = _.groupBy(results, d => yearProviderKeyFn(d.year, d?.provider?.tid));

//     const largeProviders = _.uniqBy(
//         results.map(d => d?.provider).filter(d => d.connectionSizeCategory === "large"),
//         d => d.tid
//     );

//     // if (!yearToResults || !_.keys(yearToResults ?? EMPTY_OBJECT)?.length) return null;

//     const _years = years ?? ((_.orderBy(_.keys(yearToResults), d => d, "asc") ?? EMPTY_ARRAY) as number[]);
//     const latestYear = _years?.[_years?.length - 1];
//     const previousYear = _years?.[_years?.length - 2];
//     const initialYear = _years?.[0];
//     // if (latestYear == null) return null;

//     const { visType, figureHeader, figureFooter, visHeader, visFooter } = categoryChart;

//     const latestYearData = getOperatingSurplus(kpis, yearToResults?.[latestYear]);
//     const previousYearData = getOperatingSurplus(kpis, yearToResults?.[previousYear]);
//     const initialYearData = getOperatingSurplus(kpis, yearToResults?.[initialYear]);

//     const { value: latestYearValue, valueStatus: latestYearValueStatus } = latestYearData ?? {};
//     const { value: previousYearValue } = previousYearData ?? {};
//     const unit: Unit = "%";

//     let figure: {
//         header?: LongText;
//         value: number | string;
//         decimals: number;
//         footer?: LongText;
//     } = null;
//     const providerExist = providerResults?.length > 0;
//     if (!providerExist || latestYearValue == null) {
//         const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//             ...providerTitleStartEndDiv,
//             year: latestYear,
//             value: null,
//             deltaString: null,
//             providerName: provider.name
//         });

//         const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//             ...providerTitleStartEndDiv,
//             year: latestYear,
//             value: null,
//             deltaString: null,
//             providerName: provider.name
//         });

//         figure = {
//             header:
//                 !figureHeader || figureHeader.processed.trim() === ""
//                     ? null
//                     : {
//                           processed: figureHeaderProcessed,
//                           value: figureHeaderProcessed,
//                           format: figureHeaderProcessed
//                       },
//             footer:
//                 !figureFooter || figureFooter.processed.trim() === ""
//                     ? null
//                     : {
//                           processed: figureFooterProcessed,
//                           value: figureFooterProcessed,
//                           format: figureFooterProcessed
//                       },
//             value:
//                 latestYearValueStatus != null
//                     ? latestYearValueStatus
//                     : !providerExist
//                     ? NA
//                     : previousYearValue != null && latestYearValue == null
//                     ? MD
//                     : NA,
//             decimals: 0
//         };
//     } else {
//         const delta = deltaValue(previousYearData?.value, latestYearValue);
//         const deltaString = figureDeltaString(delta, category);

//         // create content for header and footer of the figure
//         const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//             ...providerTitleStartEndDiv,
//             year: latestYear,
//             value: latestYearValue,
//             deltaString,
//             providerName: provider?.name
//         });

//         const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//             ...providerTitleStartEndDiv,
//             year: latestYear,
//             value: latestYearValue,
//             deltaString,
//             providerName: provider?.name
//         });

//         figure = {
//             decimals: latestYearValue != null ? roundValue(latestYearValue, unit as Unit).decimals : 0,
//             header:
//                 !figureHeader || figureHeader.processed.trim() === ""
//                     ? null
//                     : {
//                           processed: figureHeaderProcessed,
//                           value: figureHeaderProcessed,
//                           format: figureHeaderProcessed
//                       },
//             value:
//                 latestYearValueStatus != null
//                     ? latestYearValueStatus
//                     : previousYearValue != null && latestYearValue == null
//                     ? MD
//                     : latestYearValue == null
//                     ? NA
//                     : roundValue(latestYearValue, unit as Unit).value,

//             footer:
//                 !figureFooter || figureFooter.processed.trim() === ""
//                     ? null
//                     : {
//                           processed: figureFooterProcessed,
//                           value: figureFooterProcessed,
//                           format: figureFooterProcessed
//                       }
//         };
//     }

//     const lineDataSeriesName = kpis?.[0]?.[2] ?? latestYearData?.[0]?.indicatorTitle ?? "Line data";
//     const largeProviderAverageSeriesName = "Large provider median";

//     const values = _years.map(year => {
//         const providerValue = getOperatingSurplus(kpis, yearToResults?.[year]);
//         return providerValue?.value == null ? null : roundValue(providerValue?.value, unit as Unit).value;
//     });

//     const averages = _years.map(year => {
//         const values = largeProviders
//             .map(d => {
//                 const yearProviderKey = yearProviderKeyFn(year, d?.tid);
//                 const providerValue = getOperatingSurplus(kpis, yearProviderToAllResults[yearProviderKey]);
//                 return providerValue?.value == null ? null : roundValue(providerValue?.value, unit as Unit).value;
//             })
//             .filter(d => d != null);

//         const average = _.mean(values);
//         return roundValue(average ?? 0, unit as Unit).value;
//     });

//     const visHeaderProcessed = _.template(visHeader?.value ?? "")({
//         startYear: initialYearData?.year ?? 0,
//         endYear: latestYear
//     });

//     const visFooterProcessed = _.template(visFooter?.value ?? "")({
//         startYear: initialYearData?.year ?? 0,
//         endYear: latestYear
//     });

//     return {
//         unit,
//         year: latestYear,

//         figure: !(visType === "figure" || visType === "figureWithSolidDashLine") ? null : figure,

//         graph:
//             visType === "figure"
//                 ? null
//                 : {
//                       years: _years,
//                       lineData: values ?? [],
//                       largeProviderAverageSeriesName: `${largeProviderAverageSeriesName}`,
//                       lineDataSeriesName: `${lineDataSeriesName}`,
//                       largeProviderAverageData: averages ?? [],
//                       header:
//                           !visHeader || visHeader.processed.trim() === ""
//                               ? null
//                               : {
//                                     processed: visHeaderProcessed,
//                                     value: visHeaderProcessed,
//                                     format: visHeaderProcessed
//                                 },
//                       footer:
//                           !visFooter || visFooter.processed.trim() === ""
//                               ? null
//                               : {
//                                     processed: visFooterProcessed,
//                                     value: visFooterProcessed,
//                                     format: visFooterProcessed
//                                 }
//                   }
//     };
// };

export const fetchFigureSolidDashOperatingSurplusRatioChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProvider> => {
    const provider = providers?.[0];

    if (!metadata || !providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0)
        return null;
    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, [provider], true, categoryChart);

    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const rec = getFigureAndSolidDashGraph(
        metadata,
        provider,
        kpiReportResults,
        kpis,
        categoryChart,
        category,
        "%",
        getOperatingSurplus
    );

    // const rec = getFigureAndGraphForOperatingSurplusRatio(kpiReportResults, provider, kpis, categoryChart, category);

    if (!rec) return null;

    const { figure, graph, unit, year } = rec;
    return {
        unit,
        year,
        waterProvider: provider,
        kpiCode: null,
        schemeType: kpis?.[0]?.[1],
        title: categoryChart?.displayTitle,
        footer: null,
        figure,
        graph
    };
};
